import type { Env } from '../config';

type FirebaseConfig = {
  [K in Env]: {
    apiKey: string;
    projectId: string;
    appId: string;
    firestoreDbName?: string;
  };
};

export const firebaseConfig: FirebaseConfig = {
  get local() {
    return { ...this.development, firestoreDbName: 'local' };
  },
  test: {
    apiKey: 'AIzaSyDnVYnYd0c-bla0A5G0irw0s2vNEDQvqis',
    projectId: 'pj-tst-citizen-portal',
    appId: '1:887582816101:web:5e3d535692c1abefe6538c',
  },
  development: {
    apiKey: 'AIzaSyClhuGXfuzkmHB__inu_oqqU-2SsGjH0kQ',
    projectId: 'pj-dev-citizen-portal',
    appId: '1:415410774484:web:2d77ccfe40802685c1f641',
  },
  acc: {
    apiKey: 'AIzaSyAzGP0XTlJmbLEApO_nDEvr-THL0Afgyqg',
    projectId: 'pj-acc-citizen-portal',
    appId: '1:228356813942:web:64072bce856e4792709b57',
  },
  production: {
    apiKey: 'AIzaSyA9VOMpYpB3ibSpPX7Ii-VWPpwPdKyDdE4',
    projectId: 'pj-prd-citizen-portal',
    appId: '1:612391864960:web:755753203dc9fa4806b465',
  },
};
